// @flow

import type { ComponentType } from 'react';
import styled from 'styled-components';
import type { Theme } from '../../../../types';
import { zIndexMap } from '../../../../helpers';

type OwnProps = {
  noBox?: boolean,
};

const DiscountWrapper: ComponentType<OwnProps> = styled<any, Theme>('aside')`
  background-color: ${props => props.theme.carblock.discount.backgroundColor};
  position: absolute;
  text-align: left;
  text-transform: uppercase;
  color: ${props => props.theme.carblock.discount.color};
  min-width: 8em;
  line-height: 2em;
  font-size: ${props => props.theme.carblock.discount.fontSize};
  padding: 0.25em 1rem;
  border-radius: 0 2em 2em 0;
  left: ${props => (`-${props.theme.card.padding}`)};
  top: 0;
  margin-right: 1.25rem;
  z-index: ${zIndexMap.carblockDiscount};
`;

export default DiscountWrapper;
